import { createContext, PropsWithChildren, useContext, useState } from 'react'

type ImportLeadsContextType = {
  isPending: boolean
  setIsPending: (value: boolean) => void
}

const ImportLeadsContext = createContext<ImportLeadsContextType | undefined>(
  undefined
)

export const useImportLeads = () => {
  const context = useContext(ImportLeadsContext)
  if (!context) {
    throw new Error('useImportLeads must be used within ImportLeadsProvider')
  }
  return context
}

export const ImportLeadsProvider = ({ children }: PropsWithChildren) => {
  const [isPending, setIsPending] = useState(false)

  return (
    <ImportLeadsContext.Provider value={{ isPending, setIsPending }}>
      {children}
    </ImportLeadsContext.Provider>
  )
}
